import { sortBy } from "lodash-es";

export const sortByName = <T>(items: T[]) => sortBy(items, ["name"]);
